import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { startSurvey } from '@intercom/messenger-js-sdk';
import LoadingIndicator from 'common/LoadingIndicator';
import TinymceEditor from 'components/TinymceEditor/TinymceEditor';

// Shared component for displaying generated content
export const GeneratedContentDisplay = ({
  content,
  label = 'Generated Content',
}) => (
  <FormGroup>
    <Label>{label}:</Label>
    <div
      className="border rounded p-3 bg-light"
      style={{
        minHeight: '150px',
        maxHeight: '300px',
        overflowY: 'auto',
        whiteSpace: 'pre-wrap',
      }}
    >
      {content}
    </div>
  </FormGroup>
);

// Shared loading component
export const AILoadingState = ({ message = 'Generating your content...' }) => (
  <div className="text-center py-4">
    <LoadingIndicator loading />
    <p className="mt-2 text-muted">{message}</p>
  </div>
);

/**
 * Shared AI-enabled TinyMCE editor component
 * Handles AI button logic and key-based re-rendering when AI settings change
 */
export const AIEnabledTinymceEditor = ({
  value,
  handleChange,
  onAiButtonClick,
  aiEnabled,
  initialValue = '',
  height = '300px',
  disabled = false,
  notDisaplayTools = '',
  autofocus,
  onBlur,
  scrollIntoView,
  disableInlineImages,
  testid,
  keyPrefix = 'tinymce',
  hideAiButton = false, // New prop to hide AI button
  ...otherProps
}) => {
  // Helper function to generate AI key for re-rendering
  const getAiKey = () => {
    if (aiEnabled?.isLoading) {
      return 'loading';
    }
    return aiEnabled?.isAiEnabled ? 'ai-enabled' : 'ai-disabled';
  };

  // Determine if AI button should be shown
  const shouldShowAiButton =
    !hideAiButton && aiEnabled?.isLoading === false && aiEnabled?.isAiEnabled;

  const onAiButtonClickWithSurvey = () => {
    onAiButtonClick();
    startSurvey(50883998);
  };

  return (
    <TinymceEditor
      key={`${keyPrefix}-${getAiKey()}`}
      initialValue={initialValue}
      value={value}
      handleChange={handleChange}
      onAiButtonClick={
        shouldShowAiButton ? onAiButtonClickWithSurvey : undefined
      }
      height={height}
      disabled={disabled}
      notDisaplayTools={notDisaplayTools}
      autofocus={autofocus}
      onBlur={onBlur}
      scrollIntoView={scrollIntoView}
      disableInlineImages={disableInlineImages}
      testid={testid}
      {...otherProps}
    />
  );
};
